import { render, staticRenderFns } from "./TransactionsModal.vue?vue&type=template&id=6e4d6050&"
import script from "./TransactionsModal.vue?vue&type=script&lang=js&"
export * from "./TransactionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports